import React from 'react';
import { People, Warning } from '../../../ui/icons';
import { Swiper, SwiperSlide } from 'swiper/react';


const cards = [
    {
        title: 'International Arbitration: Law and Practice',
        img: '/images/AboutCourse/Card.png',
        location: 'Gary Born, (Wolters Kluwer);',
        link:"/book/internationalarbitrationlawlibra.pdf"
    },
    {
        title: 'Concise International Arbitration',
        img: '/images/AboutCourse/Card2.png',
        location: 'Loukas Mistelis, (Wolters Kluwer);',
        link:"/book/Concise_International_Arbitration.pdf"
    },
    {
        title: 'The Idea of Arbitration',
        img: '/images/AboutCourse/Card4.png',
        location: '(Oxford University Press);',
        link:"/book/Redfern_and_Hunter_onInternational_Arbitration.pdf"
    },
    {
        title: 'Redfern and Hunter on International Arbitration',
        img: '/images/AboutCourse/Card3.png',
        location: 'Jan Paulsson,(Oxford University Press);',
        link:"/book/The_Idea_of_Arbitration.pdf"
    },
]

const Overview = ({ course }) => {
    return (
        <>
            <div className='pt-7 flex flex-col gap-5'>
                <h2 className='text-2xl sn:text-3x;'>
                    About course
                </h2>
                <div className='flex gap-8 items-center'>
                    <div className='flex flex-col'>
                        <p className='flex items-center gap-2 text-lg'>32 231 <People /> </p>
                        <span className='text-[#757575]'>Students</span>
                    </div>
                    <div className='flex flex-col'>
                        <p className='flex items-center text-lg'>{Math.round(course?.discount_percentage)} ч. </p>
                        <span className='text-[#757575]'>Total</span>
                    </div>
                </div>
                <p className='flex items-center text-[#757575] font-normal gap-2'><Warning /> Last update: <span className='text-[#757575] font-medium'>12.12.2024, 19:00</span></p>
            </div>
            <div className='w-full h-[1px] bg-[#e9e9e9] mb-5 mt-10'></div>
            <div className='lg:flex sm:flex justify-between'>
                <h2 className='uppercase font-normal text-[#1E1E1E] text-lg sm:text-base'>description</h2>
                <div className='w-[100%] sm:w-[65%] text-[#5c5c5c]'>
                    <p>
                        {course?.course_description}
                    </p>
                </div>
            </div>
            <div className='pt-6'>
                <h2 className='uppercase font-normal text-[#1E1E1E]'>Preliminary Reading</h2>
                <p className='text-[#5C5C5C] pt-4 pb-2'>Participants are strongly encouraged to read the following books (latest editions) prior to the commencement of the course: </p>
                <div className='flex'>
                    <Swiper
                        slidesPerView={4}
                        spaceBetween={5}
                        breakpoints={{
                            0: { slidesPerView: 2.1 },
                            768: { slidesPerView: 4 }
                        }}
                    >
                        {cards.map((card, index) => (
                            <SwiperSlide key={index} className='cursor-pointer'>
                                <a className="pr-4" target='_blank' href={card.link}>
                                    <img src={`${card.img}`} alt="" className="w-full"/>
                                    <h4 className="font-semibold mt-2">{card.title}</h4>
                                    <p className="text-[#1E1E1E] opacity-80 pt-1 text-[16px]">{card.location}</p>
                                </a>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    );
};

export default Overview;
